import React from "react";
import { Section, Reveal, Icon, Button } from "../components/primitives.jsx";
import { CTABand } from "../components/blocks.jsx";
import { PageHero } from "../components/visuals.jsx";
import { renderHtml } from "../lib/html.js";
import { renderMarkdown } from "../lib/markdown.js";

function BodyContent({ body, format = "markdown", title }) {
  const html = format === "html" ? renderHtml(body, { title }) : renderMarkdown(body);
  return <div className="rich-text" dangerouslySetInnerHTML={{ __html: html }} />;
}

/* Renders a Directus article/page or scraped-fallback record in the new look. */
export function ResolvedPage({ go, c, resolved, radius = 16 }) {
  const { data, source, kind } = resolved;
  const bodyFormat = kind === "article" && source === "directus" ? "html" : "markdown";
  const eyebrow = source === "scraped" ? c.articlesPage.eyebrow : c.articlesPage.eyebrow;
  return (
    <main style={{ fontFamily: "var(--font-article)" }}>
      <PageHero eyebrow={eyebrow} title={data.title} lede={data.description || data.excerpt} radius={radius} fontFamily="var(--font-article)" />
      <Section tone="page">
        <Reveal>
          <div style={{ maxWidth: 820 }}>
            {source === "scraped" && (
              <p style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "var(--space-4) var(--space-5)", borderRadius: radius, background: "var(--surface-tint)", border: "1px solid var(--border-brand)", color: "var(--text-body)", fontSize: "var(--text-sm)", lineHeight: 1.6 }}>
                <Icon name="archive" size={18} color="var(--brand-red)" style={{ flexShrink: 0, marginTop: 2 }} />
                {c.fallbackIntro}
              </p>
            )}
            {data.body ? <BodyContent body={data.body} format={bodyFormat} title={data.title} /> : null}
            {!data.body && data.excerpt ? <p className="rich-text">{data.excerpt}</p> : null}
            <div style={{ marginTop: "var(--space-7)" }}>
              <Button variant="secondary" size="md" onClick={() => go("home")} iconLeft={<Icon name="arrow-left" size={16} />}>{c.nav.links[0].label}</Button>
            </div>
          </div>
        </Reveal>
      </Section>
      <CTABand title={c.home.ctaTitle} lede={c.home.ctaLede} button={c.home.ctaButton} onClick={() => go("contact")} radius={radius} />
    </main>
  );
}
